import {Button, Divider, Form, Row, Table, Typography} from "antd";
import React, {
  useEffect,
  forwardRef,
  useState,
  useRef,
  useImperativeHandle,
} from "react";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {LOAI_DON_THUOC, tabKeys} from "types/enums";
import {columnsSale as comlumnsSaleInit, columnsPres} from "./config";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import Reduce from "./Reduce/Reduce";
import {
  setEnableSLHoanTra,
  setReduceRef,
  setShowHoanLai,
} from "redux/reducer/medicineStore";
import {convertIosStringToDateDayjs, randomId, toNumber} from "helper/common";

const MedicinePrescription = forwardRef((props: any, ref) => {
  const [tongTienDon, setTongTienDon] = useState<any>();
  const [tongTienHoanTra, setTongTienHoanTra] = useState<any>();
  const dispatch = useAppDispatch();
  const activeTabPresciption = useAppSelector(
    state => state.medicineStore.activeTabPresciption
  );
  const typePrescription = useAppSelector(
    state => state.medicineStore.typePrescription
  );
  const detailRecord = useAppSelector(
    state => state.medicineStore.detailRecord
  );

  const selectedRecord = useAppSelector(
    state => state.medicineStore.selectedRecord
  );

  const showHoanLai = useAppSelector(state => state.medicineStore.showHoanLai);
  const [columnsSale, setColumnsSale] = useState(comlumnsSaleInit);
  const enableSLHoanTra = useAppSelector(
    state => state.medicineStore.enableSLHoanTra
  );
  const [data, setData] = useState<any[]>([]);
  const [formTable] = Form.useForm();
  const [dataPres, setDataPres] = useState<any[]>([]);
  const reduceRef = useRef<any>();
  useImperativeHandle(ref, () => ({
    getFieldValue: name => {
      return formTable.getFieldValue(name);
    },
    capNhatTongTien: () => {
      capNhatTongTien();
    },
  }));
  useEffect(() => {
    if (
      detailRecord?.listPrescriptionDetailDto?.length > 0 &&
      activeTabPresciption == tabKeys.MEDICINE_STORE.LIST_1
    ) {
      setDataTable(detailRecord.listPrescriptionDetailDto);
    }
    if (
      detailRecord?.listPrescriptionSalesDto?.length > 0 &&
      (activeTabPresciption == tabKeys.MEDICINE_STORE.LIST_2 ||
        activeTabPresciption == tabKeys.MEDICINE_STORE.LIST_3)
    ) {
      setDataTable(detailRecord.listPrescriptionSalesDto);
    }
    if (!detailRecord) {
      setDataTable([]);
      setDataPres([]);
    }
    setDataPres(detailRecord?.listPrescriptionDetailDto);
  }, [detailRecord]);
  const formatDataList = (list: any) => {
    return list?.map(e => ({
      ...e,
      key: randomId(),
      tonKho: e?.soLuongTon,
      hanSuDung: convertIosStringToDateDayjs(e?.hanSuDung),
    }));
  };
  const setDataTable = (list: any[] | []) => {
    setData(formatDataList(list));
    formTable.setFieldValue("listPrescriptionSalesDto", formatDataList(list));
  };
  const getThanhTien = (soLuong, donGia, vat) => {
    return (toNumber(soLuong) * toNumber(donGia) * (100 + toNumber(vat))) / 100;
  };
  const capNhatTongTien = () => {
    let tongTien = 0;
    formTable.getFieldValue("listPrescriptionSalesDto")?.forEach((e, index) => {
      const thanhTien = getThanhTien(e?.soLuongBan, e?.donGia, e?.vat);
      formTable.setFieldValue(
        ["listPrescriptionSalesDto", index, "tongTien"],
        thanhTien
      );
      tongTien += thanhTien;
    });

    setTongTienDon(tongTien);
  };
  const setTongTien = tongTienDon => {
    setTongTienDon(tongTienDon);
  };
  useEffect(() => {
    setDataTable([]);
  }, [selectedRecord]);
  useEffect(() => {
    dispatch(setReduceRef(reduceRef?.current));
  }, [reduceRef?.current]);
  useEffect(() => {
    if (
      detailRecord?.prescriptionDto?.status == "CB" ||
      detailRecord?.prescriptionDto?.status == "H" ||
      typePrescription == LOAI_DON_THUOC.TAO_MOI
    ) {
      dispatch(setShowHoanLai(false));
    }
  }, [detailRecord, typePrescription]);
  useEffect(() => {
    const setColumnsReturnShow = () => {
      comlumnsSaleInit.find(e => e.dataIndex == "soLuongHoanTra").show =
        showHoanLai;
      comlumnsSaleInit.find(e => e.dataIndex == "tongTienHoanTra").show =
        showHoanLai;
      setColumnsSale([...comlumnsSaleInit]);
    };
    setColumnsReturnShow();
  }, [showHoanLai]);
  useEffect(() => {
    const setDisableSLHoanTra = () => {
      {
        comlumnsSaleInit.find(e => e.dataIndex == "soLuongHoanTra").disabled =
          !enableSLHoanTra;
      }
      setColumnsSale([...comlumnsSaleInit]);
    };
    setDisableSLHoanTra();
  }, [enableSLHoanTra]);
  useEffect(() => {
    if (detailRecord?.prescriptionDto?.status == "HL") {
      dispatch(setEnableSLHoanTra(false));
    }
    setTongTienHoanTra(detailRecord?.prescriptionDto?.tongTienHoanTra);
  }, [detailRecord]);

  return (
    <div>
      {dataPres?.length > 0 && (
        <div className="container">
          <Typography.Text style={{fontWeight: "bold"}}>
            Chi tiết đơn kê
          </Typography.Text>
          <Divider style={{margin: 12}}></Divider>
          <Table
            bordered
            columns={columnsPres}
            dataSource={dataPres}
            pagination={false}
          ></Table>
        </div>
      )}

      <div className="container">
        <Row justify={"space-between"}>
          <Typography.Text style={{fontWeight: "bold"}}>
            Chi tiết đơn {showHoanLai ? "hoàn lại" : "bán"}
          </Typography.Text>
          {!showHoanLai && (
            <Button type="primary" onClick={capNhatTongTien}>
              Cập nhật tổng tiền
            </Button>
          )}
        </Row>

        <Divider style={{margin: 12}}></Divider>
        <Form form={formTable}>
          <TableInputAdd
            disabled={typePrescription == LOAI_DON_THUOC.DA_TAO ? true : false}
            scroll={{x: 1800}}
            data={[...data]}
            column={columnsSale}
            setData={setData}
            name="listPrescriptionSalesDto"
            form={formTable}
            setTongTien={setTongTien}
            setTongTienHoanTra={setTongTienHoanTra}
          ></TableInputAdd>
        </Form>

        <div style={{marginTop: 16}}>
          <Reduce
            ref={reduceRef}
            detailRecord={detailRecord}
            tongTienDon={tongTienDon}
            tongTienHoanTra={tongTienHoanTra}
          ></Reduce>
        </div>
      </div>
    </div>
  );
});
export default MedicinePrescription;
